// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-80d6f42c]{font-size:14px;display:flex;align-items:center;justify-content:space-between;padding:32px}.footer[data-v-80d6f42c],.footer a[data-v-80d6f42c]{color:hsla(0,0%,100%,.5)}.footer a[data-v-80d6f42c]{cursor:pointer}.footer .left[data-v-80d6f42c]{display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
